import React, { Component, Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, FormControl } from 'components/form';
import { InputGroup } from 'components/input';
import InputToggle from 'components/input/toggle/InputToggle';
import { Loader } from 'components/loader';
import { I18n, translate } from 'components/translate';
import { ContentBasePage } from 'modules/content';
import { PropTypes } from 'prop-types';

import { ZENDESK_EXAMPLE_SCRIPT } from './constants';
import { extractToken } from './helpers';
import ZendeskService from './ZendeskService';

import './ZendeskChat.scss';

@translate()
export default class ZendeskChat extends Component {
  static propTypes = {
    fixedBarId: PropTypes.string,
    t: PropTypes.func
  };

  state = {
    loading: true,
    widgetActive: true,
    scriptZendesk: ''
  };

  async componentDidMount() {
    const serverData = await ZendeskService.getData();

    Object.assign(this, serverData);
  }

  get scriptZendesk() {
    return this.state.scriptZendesk;
  }

  set scriptZendesk(value) {
    this.setState({ scriptZendesk: value });
  }

  get loading() {
    return this.state.loading;
  }

  set loading(value) {
    this.setState({ loading: value });
  }

  get widgetActive() {
    return this.state.widgetActive;
  }

  set widgetActive(value) {
    this.setState({ widgetActive: value });
  }

  validToken() {
    return extractToken(this.scriptZendesk);
  }

  emptyToken() {
    return this.scriptZendesk.length === 0;
  }

  validScript = () => {
    return {
      error: this.emptyToken() || this.validToken() ? false : 'invalidCode'
    };
  };

  changeActive = (event) => {
    this.widgetActive = event.target.value;
  };

  changeScript = (event) => {
    this.scriptZendesk = event.target.value;
  };

  saveHandler = () => {
    const validToken = this.validToken();

    if (this.emptyToken()) {
      return ZendeskService.deleteZendeskConfig();
    }

    if (validToken) {
      ZendeskService.updateZendeskConfig(validToken, this.widgetActive);
    }
  };

  renderLoading() {
    return <Loader key="loader" data-test="loader" mask={false} />;
  }

  renderForm() {
    const { fixedBarId, t } = this.props;
    const exampleText = `${t('general.example')}:\n${ZENDESK_EXAMPLE_SCRIPT}`;

    return (
      <Form onSubmit={this.saveHandler}>
        <div className="zendesk-config grid grid__block">
          <h2 className="zendesk-config__title">
            <I18n label="config_manager.config_zendesk.title" />
          </h2>
          <p>
            <I18n label="config_manager.config_zendesk.description" />
          </p>

          <FormControl>
            <InputGroup
              allowTags
              type="textarea"
              autoComplete="off"
              className="zendesk-config__script-input"
              labelValue={t('config_manager.config_zendesk.script_label')}
              name="scriptZendesk"
              translate={false}
              value={this.scriptZendesk}
              placeholder={exampleText}
              onChange={this.changeScript}
              mainValidation={this.validScript()}
            />
          </FormControl>

          <div className="zendesk-config__information">
            <label className="zendesk-config__infotitle">
              <FontAwesomeIcon
                icon={['fas', 'info-circle']}
                className="_mr-2"
              />
              <I18n label="config_manager.config_zendesk.information" html />
            </label>
          </div>

          <label className="zendesk-config__toggle-chat">
            <I18n label="config_manager.config_zendesk.toggle_chat" />
          </label>

          <InputToggle
            labelValue="config_manager.config_zendesk.toggle_chat_question"
            labelClass="secondary"
            value={this.widgetActive}
            onChange={this.changeActive}
            disabled={this.emptyToken()}
          />
        </div>

        {fixedBarId && <ContentBasePage.Footer onlySave />}
      </Form>
    );
  }

  render() {
    return (
      <Fragment>
        {this.loading ? this.renderLoading() : this.renderForm()}
      </Fragment>
    );
  }
}
